import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { AccountPaginationResult } from '@hdms/shared/common-types';

export interface UserAccountsResponse {
  accounts: AccountPaginationResult;
}

@Injectable({
  providedIn: 'root'
})
export class UserAccountsGqlService extends Query<UserAccountsResponse> {
  override document = gql`
    query UserAccounts {
      accounts(pagination: { pageSize: 200 }) {
        results {
          id
          originId
          address {
            company
            company2
          }
        }
      }
    }
  `;
}
